import { UpdateLineItemIntegrationEntitiesRequest } from '@vy/api-definition';
import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';
import { getPrivateApi } from '../../services/api';
import { queryKeys } from '../../services/query-key/query-keys';

export function useUpdateProductIntegrationEntities(
  lineItemId: string,
  invoiceId: string,
  options?: UseMutationOptions<void, unknown, UpdateLineItemIntegrationEntitiesRequest>,
) {
  const queryClient = useQueryClient();

  return useMutation(
    ['updateLineItemIntegrationEntities', lineItemId],
    async (updateLineItemIntegrationEntitiesRequest: UpdateLineItemIntegrationEntitiesRequest) => {
      const api = getPrivateApi();

      await api.updateLineItemIntegrationEntities({
        lineItemId,
        updateLineItemIntegrationEntitiesRequest,
      });
    },
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries(queryKeys.productsIntegrationEntities(invoiceId));
      },
      ...options,
    },
  );
}
